import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosObj } from "../../../config/apiClients";
import { ClientInfoChangeRequestState } from "../../types";

const initialState: ClientInfoChangeRequestState = {
  isLoading: false,
  clientInfoChangeRequests: [],
  pagination: {
    totalItems: 0,
    currentPage: 1,
    totalPages: 1,
    hasNextPage: false
  }
}

type ClientChangeRequest = {
  _id: string,
  userId: string,
  status: string;
}

export const getAllUserInfoRequests = createAsyncThunk(
  "/user/personalInfo/getUpdates",
  async ({ paramPage, paramLimit }: { paramPage: number; paramLimit: number }, { rejectWithValue }) => {
    try {
      const response = await axiosObj.get(`/user/personalInfo/getUpdates?paramPage=${paramPage}&paramLimit=${paramLimit}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Fetch Clients Info Request Changes' });
    }
  }
)

export const updateUserInfoRequestStatus = createAsyncThunk(
  "/user/personalInfo/statusUpdate",
  async (requestChange: ClientChangeRequest, { rejectWithValue }) => {
    try {
      const response = await axiosObj.patch('/user/personalInfo/statusUpdate', requestChange);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Update Request Status' });
    }
  }
)

const clientInfoChangeRequestSlice = createSlice({
  name: "clientInfoChangeRequest",
  initialState,
  reducers: {
    requestStatusUpdate: (state, action) => {
      const { id, status } = action.payload;
      const request = state.clientInfoChangeRequests.find((request) => request._id === id);
      if (request) {
        request.status = status;
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllUserInfoRequests.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllUserInfoRequests.fulfilled, (state, action) => {
        state.isLoading = false;
        state.clientInfoChangeRequests = action.payload.payload.newUserUpdates;
        state.pagination = {
          totalItems: action.payload.payload.totalItems,
          currentPage: action.payload.payload.page,
          totalPages: action.payload.payload.totalPages,
          hasNextPage: action.payload.payload.hasNextPage
        };
      })
      .addCase(getAllUserInfoRequests.rejected, (state) => {
        state.isLoading = false;
        state.clientInfoChangeRequests = [];
      })
      .addCase(updateUserInfoRequestStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateUserInfoRequestStatus.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(updateUserInfoRequestStatus.rejected, (state) => {
        state.isLoading = false;
      })
  }
});

export const { requestStatusUpdate } = clientInfoChangeRequestSlice.actions;

export default clientInfoChangeRequestSlice.reducer;